import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    "en": {
        translation: {
          "Assist":"Assist",
        }
      },
    "en-US": {
      translation: {
        "Assist":"Assist",
      }
    },
    "en-GB": {
        translation: {
          "Outcalls":"Outgoing",
          "Assist":"Assist",
        }
      }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  //.use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    detection:{
        order:["navigator","querystring","localStorage"]
    },
    //debug: true,
    resources,
    //lng: "en-GB",
    fallbackLng: "en", // use en if detected lng is not available
    keySeparator: false, // we do not use keys in form messages.welcome
    nonExplicitSupportedLngs:true,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;